import React from 'react';

import DashboardComptes from 'components/Comptes/DashboardComptes';

const PageAdministration: React.FC = () => {
  return <DashboardComptes />;
};

export default PageAdministration;
